import React, { useEffect } from "react";
import AutoCarousel from "../../components/AutoCarousel/AutoCarousel";
import ContentCard from "../../components/ContentCard/ContentCard";
import CardGrid from "../../components/CardGrid/CardGrid";
import TestimonialCard from "../../components/TestimonialCard/TestimonialCard";
import DailyChallengeCard from "../../components/DailyChallengeCard/DailyChallengeCard";
import useDashboardData from "./hook/useDashboardData";
import MUILoader from "../../components/MUILoader/MUILoader";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { removeEntity, setEntity } from "../../common/CommonFunctions";

const Dashboard = () => {
  const navigate = useNavigate();
  const {
    data,
    loading,
    carouselSlides,
    // refreshData,
  } = useDashboardData();

  // Card Layout
  const cardLayout = {
    vartical: "vertical",
    horizontal: "horizontal",
    ebook: "ebook",
  };

  // Render function for ContentCard
  const renderContentCard = (card, index, onItemClick, layout) => (
    <ContentCard
      layout={layout || cardLayout.vartical}
      image={card.thumbnailImage}
      title={card?.topicName || card?.title}
      subtitle={dayjs(card.updatedAt).format("D MMM, YYYY")}
      onClick={() => onItemClick(card, index)}
    />
  );

  // One reusable Section to cut repetition
  const Section = ({
    keyName,
    title,
    enableHorizontalScroll,
    size,
    onSeeAllClick,
    layout,
    handleEntityClick,
  }) => {
    const items = data[keyName] || [];
    const isLoading = loading[keyName];
    if (!items.length && !isLoading) return null;

    return (
      <div className="mb-4">
        <CardGrid
          data={items}
          renderItem={(card, index, onItemClick) =>
            renderContentCard(card, index, onItemClick, layout)
          }
          type={layout}
          onItemClick={(item, index) => {
            handleEntityClick && handleEntityClick(item);
          }}
          enableHorizontalScroll={enableHorizontalScroll || false}
          showHeader={true}
          headerTitle={title}
          showSeeAll={true}
          seeAllText="See all"
          size={size}
          onSeeAllClick={onSeeAllClick}
        />
        {isLoading && <MUILoader IsMiniLoader />}
      </div>
    );
  };

  useEffect(() => {
    removeEntity(process.env.REACT_APP_ENTITY_DETAILS);
  }, [])

  if (loading?.global) {
    return <MUILoader />;
  }

  return (
    <React.Fragment>
      {carouselSlides.length > 0 ? (
        <div className="mb-4">
          <AutoCarousel
            items={carouselSlides}
            height="50vh"
            onReadNow={(slide) => {
              const entity = slide?.raw || slide;
              setEntity(entity);
              navigate("/magazine");
            }}
          />
        </div>
      ) : (
        (loading.quote || loading.shloka) && <MUILoader IsMiniLoader />
      )}

      {/* Daily Challenge Card */}
      <DailyChallengeCard
        onClick={() => {
          navigate("/daily-challenge");
        }}
      />

      {/* Latest Podcasts */}
      <Section
        keyName="podcasts"
        title="Podcasts"
        layout={cardLayout.vartical}
        enableHorizontalScroll
        onSeeAllClick={() => navigate("/podcast")}
        handleEntityClick={(item) => {
          setEntity(item);
          navigate("/podcast");
        }}
      />

      {/* Bhakti Sangeet */}
      <Section
        keyName="bhaktiSangeet"
        title="Bhakti Sangeet"
        layout={cardLayout.vartical}
        enableHorizontalScroll
        onSeeAllClick={() => navigate("/bhakti-sangeet")}
        handleEntityClick={(item) => {
          setEntity(item);
          navigate("/bhakti-sangeet");
        }}
      />

      {/* Latest Topics */}
      <Section
        keyName="topics"
        title="Educational Topics"
        layout={cardLayout.vartical}
        enableHorizontalScroll
        onSeeAllClick={() => navigate("/educational-topics")}
        handleEntityClick={(item) => {
          setEntity(item);
          navigate("/educational-topics");
        }}
      />
      
      {/* Devotional News Section */}
      <Section
        keyName="devotionalNews"
        title="Devotional News"
        layout={cardLayout.horizontal}
        size={{ xs: 12, sm: 6, md: 6, lg: 6 }}
        onSeeAllClick={() => navigate("/devotional-news")}
        handleEntityClick={(item) => {
          setEntity(item);
          navigate("/devotional-news");
        }}
      />

      {/* Information Section */}
      <Section
        keyName="information"
        title="Information Section"
        layout={cardLayout.horizontal}
        size={{ xs: 12, sm: 6, md: 6, lg: 6 }}
        onSeeAllClick={() => navigate("/information-section")}
        handleEntityClick={(item) => {
          setEntity(item);
          navigate("/information-section");
        }}
      />

      {/* E-Books Cards Section */}
      <Section
        keyName="ebooks"
        title="E-Books"
        layout={cardLayout.ebook}
        enableHorizontalScroll
        onSeeAllClick={() => navigate("/e-books")}
        handleEntityClick={(item) => {
          setEntity(item);
          navigate("/e-books");
        }}
      />

      {/* User Testimonials Section - ADD THIS! */}
      <div className="mb-4">
        <CardGrid
          data={[]} // Empty data since we're only using for header
          showHeader={true}
          headerTitle="User Testimonials"
          showSeeAll={false}
          className="testimonials-section"
        />
        {loading.testimonials ? (
          <MUILoader IsMiniLoader />
        ) : (
          <TestimonialCard
            testimonials={data.testimonials || []}
            autoPlay={true}
            autoPlayInterval={6000}
            showNavigation={true}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default Dashboard;
